
// 能发送异步ajax请求的函数模块
// 封装axios对象
// 函数返回值是promise对象:
        // 1、优化，统一处理请求异常
        //2、异步得到的不是response，而是response.data
import axios from 'axios';
import {message,Alert }  from 'antd';

var PathBASE=window.location.href;
    PathBASE = PathBASE.split("#/")[0]; 

export default function ajax(url,data,type){
    return new Promise((resolve,reject)=>{
        // 1、执行异步ajax请求
       
        // console.log('=======ss=========')
        // console.log(data);
        // console.log(url);
        // console.log('========ee=========')

        const token = localStorage.getItem('token_k');
        data.token = token;

        let promise;
        if(type==='GET'){
            promise= axios.get(url,{//配置对象
                params:data   //请求参数
            })

         }else{ //POST
            // console.log(data)
            promise= axios.post(url,data,{headers: {'Content-Type': 'application/x-www-form-urlencoded'}})

        }
        // 如果成功了调用resolve(value)
        promise.then(response=>{
            console.log('==============response==============', response)
            if(response.data.code===0){
                message.error(response.data.msg);
                // memoryUtils.user={};
                // memoryUtils.loginTime='';
                // window.localStorage.removeItem('UserInfo');
                // window.localStorage.removeItem('LoginTime');
                // window.localStorage.clear();  
                window.location.href=PathBASE+"#/login";

            // }else if(response.data.code===9){
            //     resolve(response)
            }else{
                // message.error(response.data.msg,8);
                resolve(response)
                // <Alert message="Success Tips" type="success" showIcon />
            }
            // 如果失败了，不调用resolve(value)
        }).catch(error=>{
            message.error('请求出错了'+error.message)
        })
       
    })
    

}

